<template src="../../templates/form/farm-user-form.pug" lang="pug"></template>

<script>
import Modal from './Modal.vue'
import { mapActions, mapGetters } from 'vuex'
import _filter from 'lodash/filter'
import _includes from 'lodash/includes'
import _map from 'lodash/map'

export default {
    name: 'FarmUserForm',
    props: ['farmToUpdate'],
    components: {
        Modal
    },
    data() {
        return {
            hoveredUser: null,
            farmUser: this.farmToUpdate.users,
            rolesList: [
                'manager',
                'collaborator',
                'visitor'
            ]
        }
    },
    computed: {
        ...mapGetters(['users']),
        usersWithoutRole() {
            let self = this
            return _filter(this.users, function(u) {
                return !_includes(_map(self.farmUser, 'userId'), u.id)
            })
        }
    },
    created() {
        this.fetchUsers()
    },
    methods: {
        ...mapActions([
            'fetchUsers',
            'createFarmuser',
            'updateFarmuser',
            'deleteFarmuser'
        ]),
        close() {
            this.$parent.showFarmUserForm = false
            this.farmUser = null
        },
        addUser(u) {
            this.createFarmuser([
                this.farmToUpdate.id,
                {
                    userId: u.id,
                    role: 'visitor',
                    firstname: u.firstname,
                    lastname: u.lastname
                }
            ]).then(response => {
                this.farmUser = response
            })
        },
        editUser(index) {
            let self = this
            this.$nextTick(function() {
                self.updateFarmuser(self.farmUser[index]).then(response => {
                    self.farmUser = response
                })
            })
        },
        removeUser(linkId) {
            this.deleteFarmuser([this.farmToUpdate.id, linkId]).then(
                response => {
                    this.farmUser = response
                }
            )
        }
    }
}
</script>

<style lang="sass">
    @import '../../sass/mixin/color'
    @import '../../sass/mixin/flex'

    #farm-user-modal
        .modal-container
            .modal-header
                background-color: $pc_niceyellow
                color: white
            .modal-body
                form
                    .users-without-role
                        @include flexbox
                        @include flex-wrap(wrap)
                        @include justify-content(flex-start)
                        @include flex-direction(row)
                        .user-wrapper
                            background-color: $dd-strong-cyan
                            color: white
                            padding: 2px 8px
                            margin-right: 8px
                            margin-bottom: 8px
                            cursor: pointer
                            @include flexbox
                            @include flex-direction(row)
                            .block-action
                                @include flex-center
                                margin-left: 4px
                    table
                        thead
                            background-color: $dd-strong-cyan
                        tbody
                            .select
                                @include flex-center
                                .form-select
                                    width: 150px
                                    background: url('/img/br_down.png') 96% no-repeat #fff
                                    border-bottom: 2px solid $dd-strong-cyan
                                    border-left: 2px solid $dd-strong-cyan
                                    border-right: 2px solid $dd-strong-cyan
                                    border-top: transparent
                                    padding: 0.25em
                                    font-size: 16px
                                    font-weight: bold
                                    -webkit-appearance: none
                                    -moz-appearance: none
                                    appearance: none
        .modal-footer
                    .button-cancel
                        width: 100%

</style>
